/* eslint-disable no-nested-ternary */
import { css } from 'styled-components';
import { Color } from '@pushwoosh/kit-constants';
export const colors = {
  primary: {
    shape: {
      base: {
        color: `var(--primary-shape-base-color, ${Color.CLEAR})`,
        bgColor: `var(--primary-shape-base-bg-color, ${Color.PRIMARY})`
      },
      disabled: {
        bgColor: `var(--primary-shape-disabled-bg-color, ${Color.LOCKED})`
      },
      hover: {
        bgColor: `var(--primary-shape-hover-bg-color, ${Color.PRIMARY_HOVER})`
      }
    },
    ghost: {
      base: {
        color: `var(--primary-ghost-base-color, ${Color.PRIMARY})`,
        bgColor: 'var(--primary-ghost-base-bg-color, transparent)'
      },
      disabled: {
        color: `var(--primary-ghost-disabled-color, ${Color.LOCKED})`
      },
      hover: {
        color: `var(--primary-ghost-hover-color, ${Color.PRIMARY_HOVER})`,
        bgColor: `var(--primary-ghost-hover-bg-color, ${Color.BRIGHT_LIGHT})`
      }
    }
  },
  secondary: {
    shape: {
      base: {
        color: `var(--secondary-shape-base-color, ${Color.MAIN})`,
        bgColor: `var(--secondary-shape-base-bg-color, ${Color.FROZEN})`,
        borderColor: `var(--secondary-shape-base-border-color, ${Color.FORM})`
      },
      disabled: {
        color: `var(--secondary-shape-disabled-color, ${Color.LOCKED})`
      },
      hover: {
        color: `var(--secondary-shape-hover-color, ${Color.PRIMARY_HOVER})`,
        bgColor: `var(--secondary-shape-hover-bg-color, ${Color.BRIGHT_LIGHT})`,
        borderColor: 'var(--secondary-shape-hover-border-color, #005EFF24)'
      }
    },
    ghost: {
      base: {
        color: `var(--secondary-ghost-base-color, ${Color.MAIN})`,
        bgColor: 'var(--secondary-ghost-base-bg-color, transparent)'
      },
      disabled: {
        color: `var(--secondary-ghost-disabled-color, ${Color.LOCKED})`
      },
      hover: {
        color: `var(--secondary-ghost-hover-color, ${Color.PRIMARY_HOVER})`,
        bgColor: `var(--secondary-ghost-hover-bg-color, ${Color.BRIGHT_LIGHT})`
      }
    }
  },
  danger: {
    shape: {
      base: {
        color: `var(--danger-shape-base-color, ${Color.CLEAR})`,
        bgColor: `var(--danger-shape-base-bg-color, ${Color.DANGER})`
      },
      disabled: {
        color: `var(--danger-shape-disabled-color, ${Color.LOCKED})`
      },
      hover: {
        bgColor: `var(--danger-shape-hover-bg-color, ${Color.DANGER_HOVER})`
      }
    },
    ghost: {
      base: {
        color: `var(--danger-ghost-base-color, ${Color.DANGER})`,
        bgColor: 'var(--danger-ghost-base-bg-color, transparent)'
      },
      disabled: {
        color: `var(--danger-ghost-disabled-color, ${Color.LOCKED})`
      },
      hover: {
        color: `var(--danger-ghost-hover-color, ${Color.DANGER_HOVER})`,
        bgColor: `var(--danger-ghost-hover-bg-color, ${Color.DANGER_LIGHT})`
      }
    }
  }
};
export function createColors(buttonColors) {
  const base = {
    borderColor: 'transparent',
    ...buttonColors.base
  };
  const disabled = {
    ...base,
    ...buttonColors.disabled
  };
  const hover = {
    ...base,
    ...buttonColors.hover
  };
  const hoverCss = css(["&:hover:not([disabled]){color:", ";background-color:", ";border-color:", ";}"], hover.color, hover.bgColor, hover.borderColor);
  return css(["color:", ";background-color:", ";border-color:", ";&:disabled{color:", ";background-color:", ";border-color:", ";}", " &:active:not([disabled]){color:", ";background-color:", ";border-color:", ";opacity:0.5;}"], ({
    $isOpen,
    $isDisabled
  }) => $isOpen ? Color.CLEAR : $isDisabled ? disabled.color : base.color, ({
    $isOpen,
    $isDisabled
  }) => $isOpen ? Color.MAIN : $isDisabled ? disabled.bgColor : base.bgColor, ({
    $isOpen,
    $isDisabled
  }) => $isOpen ? Color.MAIN : $isDisabled ? disabled.borderColor : base.borderColor, disabled.color, disabled.bgColor, disabled.borderColor, ({
    $isOpen
  }) => $isOpen ? '' : hoverCss /* sc-custom "display: none;" */, hover.color, hover.bgColor, hover.borderColor);
}